import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RestaurantService } from '../../../../services/restaurant.service';
import { FNFResponse } from '../../../../models/response';
import { ConfirmationDialogComponent } from '../../../controls/fnf-confirmation/confirmation-dialog/confirmation-dialog.component';
import { AddServingTimeModalComponent } from '../../add-menu/modal/add-serving-time-modal/add-serving-time-modal.component';

@Component({
  selector: 'app-serving-time',
  standalone: true,
  imports: [],
  templateUrl: './serving-time.component.html',
  styleUrl: './serving-time.component.css',
})
export class ServingTimeComponent {
  restaurantService = inject(RestaurantService);
  ngxSpinnerService = inject(NgxSpinnerService);
  servingTimes: any = [];

  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.getServingTimes();
  }

  getServingTimes() {
    this.ngxSpinnerService.show();
    this.restaurantService.getServingTime().subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
          this.ngxSpinnerService.hide();
          return;
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
          this.ngxSpinnerService.hide();
          return;
        }
        this.servingTimes = response.data;
        this.ngxSpinnerService.hide();
      },
      error: () => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.ngxSpinnerService.hide();
      },
    });
  }

  addNewServingTime(time?: any) {
    const dialogRef = this.dialog.open(AddServingTimeModalComponent, {
      data: { allServingTimes: this.servingTimes, servingTime: time },
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result !== undefined && result != '') {
        if (time) {
          this.editServingTime(result, time.id);
        } else {
          this.saveServingTime(result);
        }
      }
    });
  }

  saveServingTime(servingTime: any) {
    this.ngxSpinnerService.show();
    this.restaurantService.addServingTime(servingTime).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
          this.ngxSpinnerService.hide();
          return;
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
          this.ngxSpinnerService.hide();
          return;
        }
        this.servingTimes.push(servingTime);
        this.ngxSpinnerService.hide();
      },
      error: (error) => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.ngxSpinnerService.hide();
      },
    });
  }

  editServingTime(servingTime: any, id: any) {
    this.ngxSpinnerService.show();
    this.restaurantService.editServingTime(servingTime, id).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
          this.ngxSpinnerService.hide();
          return;
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
          this.ngxSpinnerService.hide();
          return;
        }
        this.ngxSpinnerService.hide();
        this.getServingTimes();
      },
      error: (error) => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.ngxSpinnerService.hide();
      },
    });
  }

  deleteServingTimeConfirm(time: any) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: 'This will permanently delete this serving time and you can’t undo this later.',
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel',
        },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteServingTime(time);
      }
    });
  }

  deleteServingTime(time: any) {
    this.ngxSpinnerService.show();
    this.restaurantService.deleteServingTime(time.id).subscribe({
      next: (response: FNFResponse<any>) => {
        if (!response.data && response.error) {
          this.toastr.error(response.error.error?.message || response.error.message, 'Error');
          this.ngxSpinnerService.hide();
          return;
        } else if (!response.data) {
          this.toastr.error('No data found!', 'Error');
          this.ngxSpinnerService.hide();
          return;
        }
        this.toastr.success(response.data.message, 'Success');
        this.ngxSpinnerService.hide();
        this.getServingTimes();
      },
      error: () => {
        this.toastr.error('Unable to complete your action. Please try again later.', 'Error');
        this.ngxSpinnerService.hide();
      },
    });
  }
}
